import moment from "moment";
export default {
    // 上次执行函数
    lastFn: null,
    // 函数防抖 (只执行最后一次点击)
    // 在指定时间段内只执行最后一次点击
    // 注意：防抖函数不能校验fn传递的函数是否和上一次传递的函数相同
    // 只能校验限防抖数上次执行时间，使用时应避免不同函数同时调用防抖函数
    // 当然这个是可以扩展此函数来处理的，不过现在并没有这种需求，暂时搁置
    // fn 函数
    // params 参数 选填
    // delay 指定时间段 单位为毫秒
    debounce(fn, params, delay = 200) {
        const lastFn = this.lastFn;
        if (lastFn) {
            clearTimeout(lastFn);
        }
        this.lastFn = setTimeout(() => {
            this.lastFn = null;
            fn(params);
        }, delay);
    },

    // 函数上次执行时间
    lastLimitingTime: 0,
    // 限流函数
    // 在指定时间段内只执行第一个函数
    // 注意：限流函数不能校验fn传递的函数是否和上一次传递的函数相同
    // 只能校验限流函数上次执行时间，使用时应避免不同函数同时调用限流函数
    // 当然这个是可以扩展此函数来处理的，不过现在并没有这种需求，暂时搁置
    // fn 函数
    // params 参数 选填
    // delay 指定时间段 单位为毫秒
    limiting(fn, params, delay = 200) {
        // 获取当前时间
        const now = +new Date();
        // console.log(now - this.lastLimitingTime, delay);
        // 如果当前时间减去函数上次执行时间大于指定时间段
        // 就执行指定函数
        if (now - this.lastLimitingTime > delay) {
            fn(params);
            // 记录函数上次执行时间
            this.lastLimitingTime = +new Date();
        }
    },
    // 计算时间差
    diffTime(startDate, endDate, formatt = 'YYYY-MM-DD HH:mm:ss') {
        if (!startDate || !endDate) {
            return null;
        }
        startDate = moment(startDate, formatt);
        endDate = moment(endDate, formatt);
        const du = moment.duration(endDate - startDate, 'ms'),
            mins = du.get('minutes'),
            ss = du.get('seconds');
        let hours = du.get('hours'),
            day = du.get('day');
        if (hours == 23 && mins == 30) {
            day = day + 1;
            hours = 0;
        } else if (hours < 23 && mins == 30) {
            hours = hours + 1;
        }
        return {
            day,
            hours,
            mins,
            ss
        };
    },
    // 格式化时间
    formattStringTime(date, toFormatt = 'YYYY.MM.DD', formFormatt = 'YYYY-MM-DD HH:mm:ss') {
        return moment(date, formFormatt).format(toFormatt);
    },
    // 根据关键字段查询索引
    getListIndex(list, v, name = 'id') {
        const length = list.length - 1;
        let index = -1,
            i;
        for (i = length; i >= 0; i--) {
            if (list[i][name] == v) {
                index = i;
                break;
            }
        }
        return index
    },

    eachList(list, callBack) {
        if (!list) {
            return list
        }
        const length = list.length
        let item, i
        for (i = 0; i < length; i++) {
            item = list[i]
            if (callBack) {
                callBack(item)
            }
        }
        return list
    },
    // 取字符串后几位
    sliceLast(v, num = 4) {
        return v ? v.slice(-num) : '';
    },
    /**
     * 字符串加*
     * @param {any} str 字符串
     * @param {any} frontLen 开始位置 从0开始,开始位置不会被替换为*
     * @param {any} endLen 结束位置 从0开始,结束位置会被替换为*
     */
    plusXing(str, frontLen, endLen) {
        const len = endLen - frontLen
        let xing = ''
        for (let i = 0; i < len; i++) {
            xing += '*'
        }
        return str.substr(0, frontLen) + xing + str.substr(endLen)
    },
    /**
     * 为数字加上单位：万或亿
     *
     * 例如：
     * 数字上千用K表示，四舍五入保留小数点后1位
     * 例如1560人记做1.6K已兑换
     * 同理，人数达到上万人用W表示
     * 10000 => 1万
     * 99000 => 9.9万
     * 566000 => 56.6万
     * 5660000 => 566万
     * 44440000 => 4444万
     * 11111000 => 1111.1万
     * 444400000 => 4.44亿
     * 40000000,00000000,00000000 => 4000万亿亿
     * 4,00000000,00000000,00000000 => 4亿亿亿
     *
     * @param {number} number 输入数字.
     * @param {number} decimalDigit 小数点后最多位数，默认为2
     * @return {string} 加上单位后的数字
     */
    plusNumber(value) {
        if (value < 1000 || value > 9999) {
            return this.addChineseUnit(value, 1);
        } else {
            // 千位数特殊处理
            const show = ((value / Math.pow(1000, 1))).toFixed(1);
            return `${show}K`;
        }
    },
    /**
     * 为数字加上单位：万或亿
     *
     * 例如：
     * 1000.01 => 1000.01
     * 10000 => 1万
     * 99000 => 9.9万
     * 566000 => 56.6万
     * 5660000 => 566万
     * 44440000 => 4444万
     * 11111000 => 1111.1万
     * 444400000 => 4.44亿
     * 40000000,00000000,00000000 => 4000万亿亿
     * 4,00000000,00000000,00000000 => 4亿亿亿
     *
     * @param {number} number 输入数字.
     * @param {number} decimalDigit 小数点后最多位数，默认为2
     * @return {string} 加上单位后的数字
     */
    addWan(integer, number, mutiple, decimalDigit) {
        var me = this;
        var digit = me.getDigit(integer);
        if (digit > 3) {
            var remainder = digit % 8;
            if (remainder >= 5) { // ‘十万’、‘百万’、‘千万’显示为‘万’
                remainder = 4;
            }
            return Math.round(number / Math.pow(10, remainder + mutiple - decimalDigit)) / Math.pow(10, decimalDigit) + 'W';
        } else {
            return Math.round(number / Math.pow(10, mutiple - decimalDigit)) / Math.pow(10, decimalDigit);
        }
    },
    getDigit(integer) {
        var digit = -1;
        while (integer >= 1) {
            digit++;
            integer = integer / 10;
        }
        return digit;
    },
    addChineseUnit(number, decimalDigit) {
        var me = this;
        decimalDigit = decimalDigit == null ? 2 : decimalDigit;
        var integer = Math.floor(number);
        var digit = me.getDigit(integer);
        // ['个', '十', '百', '千', '万', '十万', '百万', '千万'];
        var unit = [];
        if (digit > 3) {
            var multiple = Math.floor(digit / 8);
            if (multiple >= 1) {
                var tmp = Math.round(integer / Math.pow(10, 8 * multiple));
                unit.push(me.addWan(tmp, number, 8 * multiple, decimalDigit));
                for (var i = 0; i < multiple; i++) {
                    unit.push('亿');
                }
                return unit.join('');
            } else {
                return me.addWan(integer, number, 0, decimalDigit);
            }
        } else {
            return number;
        }
    },
    // 验证obj对象是否为空
    // {},null,''等都视为空
    objectIsEmpty(values) {
        return !(values && Object.keys(values).length);
    },
    // 是否string类型
    isString(value) {
        return typeof value === 'string'
    },
    isArray(o) {
        return Object.prototype.toString.call(o) === '[object Array]'
    },
    isObject(obj) {
        // 默认
        // 如果有数据
        for (const item in obj) {
            if (obj[item]) {
                return true
            }
        }
        // 如果没有数据
        return false;
    },
    isBoolean(value) {
        return typeof value === 'boolean'
    },
    // 正则表达式验证
    regexVerify(regex, value) {
        return value ? regex.test(value) : true;
    },
    // 是否为空
    isEmpty(v) {
        if (Number.isFinite(v)) {
            return true;
        } else {
            return v;
        }
    },
    // 国内身份证验证
    isIdCard(sIdCard) {
        const CheckIdCard = {
            // Wi 加权因子 Xi 余数0~10对应的校验码 Pi省份代码
            Wi: [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
            Xi: [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2],
            Pi: [11, 12, 13, 14, 15, 21, 22, 23, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 50, 51, 52, 53, 54, 61, 62, 63, 64, 65, 71, 81, 82, 91],

            brithday18(sIdCard) {
                const year = parseFloat(sIdCard.substr(6, 4));
                const month = parseFloat(sIdCard.substr(10, 2));
                const day = parseFloat(sIdCard.substr(12, 2));
                const checkDay = new Date(year, month - 1, day);
                const nowDay = new Date();
                if (year >= 1900 && year <= nowDay.getFullYear() && month == (checkDay.getMonth() + 1) && day == checkDay.getDate()) {
                    return true;
                }
            },

            // 检验15位身份证号码出生日期是否有效
            brithday15(sIdCard) {
                const year = parseFloat(sIdCard.substr(6, 2));
                const month = parseFloat(sIdCard.substr(8, 2));
                const day = parseFloat(sIdCard.substr(10, 2));
                const checkDay = new Date(year, month - 1, day);
                if (month == (checkDay.getMonth() + 1) && day == checkDay.getDate()) {
                    return true;
                }
            },

            // 检验校验码是否有效
            validate(sIdCard) {
                const aIdCard = sIdCard.split('');
                let sum = 0;
                for (let i = 0; i < CheckIdCard.Wi.length; i++) {
                    sum += CheckIdCard.Wi[i] * aIdCard[i]; // 线性加权求和
                }
                const index = sum % 11; // 求模，可能为0~10,可求对应的校验码是否于身份证的校验码匹配
                if (CheckIdCard.Xi[index] == aIdCard[17].toUpperCase()) {
                    return true;
                }
            },
            // 检验输入的省份编码是否有效
            province(sIdCard) {
                const p2 = sIdCard.substr(0, 2);
                for (let i = 0; i < CheckIdCard.Pi.length; i++) {
                    if (CheckIdCard.Pi[i] == p2) {
                        return true;
                    }
                }
            }
        };

        if (sIdCard.match(/^\d{14,17}(\d|X)$/g) == null) { // 判断是否全为18或15位数字，最后一位可以是大小写字母X
            // 允许用户输入大小写X代替罗马数字的Ⅹ
            return false;
        } else if (sIdCard.length == 18) {
            if (CheckIdCard.province(sIdCard) && CheckIdCard.brithday18(sIdCard) && CheckIdCard.validate(sIdCard)) {
                return true;
            }
            return false;
        } else if (sIdCard.length == 15) {
            if (CheckIdCard.province(sIdCard) && CheckIdCard.brithday15(sIdCard)) {
                return true;
            }
            return false;
        }
    },
    // 校验银行卡卡号
    luhnCheck(bankno) {
        const lastNum = bankno.substr(bankno.length - 1, 1); // 取出最后一位（与luhn进行比较）
        const first15Num = bankno.substr(0, bankno.length - 1); // 前15或18位
        const newArr = [];
        for (let i = first15Num.length - 1; i > -1; i--) { // 前15或18位倒序存进数组
            newArr.push(first15Num.substr(i, 1));
        }
        const arrJiShu = []; // 奇数位*2的积 <9
        const arrJiShu2 = []; // 奇数位*2的积 >9
        const arrOuShu = []; // 偶数位数组
        for (let j = 0; j < newArr.length; j++) {
            if ((j + 1) % 2 == 1) { // 奇数位
                if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
                else arrJiShu2.push(parseInt(newArr[j]) * 2);
            } else {
                // 偶数位
                arrOuShu.push(newArr[j]);
            }
        }

        const jishu_child1 = []; // 奇数位*2 >9 的分割之后的数组个位数
        const jishu_child2 = []; // 奇数位*2 >9 的分割之后的数组十位数
        for (let h = 0; h < arrJiShu2.length; h++) {
            jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
            jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
        }

        let sumJiShu = 0; // 奇数位*2 < 9 的数组之和
        let sumOuShu = 0; // 偶数位数组之和
        let sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
        let sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
        let sumTotal = 0;
        for (let m = 0; m < arrJiShu.length; m++) {
            sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
        }

        for (let n = 0; n < arrOuShu.length; n++) {
            sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
        }

        for (let p = 0; p < jishu_child1.length; p++) {
            sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
            sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
        }
        // 计算总和
        sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

        // 计算luhn值
        const k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
        const luhn = 10 - k;

        if (lastNum == luhn) {
            return true;
        } else {
            return false;
        }
    },
    array2Tree(
        data,
        root = "",
        idTxt = "id",
        pidTxt = "layer",
        pushTxt = "children"
    ) {
        // 递归方法
        function getNode(id) {
            const node = [],
                length = data.length;
            let i = 0,
                item;
            for (; i < length; i++) {
                item = data[i];
                if (item[pidTxt] == id) {
                    item[pushTxt] = getNode(item[idTxt]);
                    node.push(item);
                }
            }
            if (node.length == 0) {
                return;
            } else {
                return node;
            }
        }
        // 使用根节点
        return getNode(root);
    }
}